import { useEffect, useRef, VFC, RefObject } from 'react';
import { connect, FormikProps } from 'formik';

type ScrollErrorToViewProps = {
  formik: FormikProps<any>;
  fieldRefs: Record<string, RefObject<HTMLDivElement>>;
};
const ScrollErrorToView: VFC<ScrollErrorToViewProps> = ({ formik, fieldRefs }) => {
  const { submitCount, isValid, errors } = formik;
  const prevSubmitCountRef = useRef(submitCount);

  useEffect(() => {
    const shouldScrollIntoError = submitCount > prevSubmitCountRef.current && !isValid;
    if (shouldScrollIntoError) {
      const errorKeys = Object.keys(errors);
      const firstInvalidField = fieldRefs[errorKeys[0]].current;

      if (firstInvalidField) {
        firstInvalidField.scrollIntoView();
      }
    }

    prevSubmitCountRef.current = submitCount;
  }, [submitCount, errors, isValid, fieldRefs]);

  return null;
};

const Connected = connect<Omit<ScrollErrorToViewProps, 'formik'>>(ScrollErrorToView);

export default Connected;
